import { trackFooterNavigationClicked } from '@mc/pre-paywall-events'

export const trackNavigationClick = (action: string) => {
  trackFooterNavigationClicked({ action, level: 'footer_primary' })
}
